import React from 'react';
import styles from './css/ObitWriterCTA.styl';
import CTABlock from '../CTABlock';
import appConfig from '../../../../../appConfig/AppConfig';

const data = {
  title: 'Write an Obituary',
  blurb:
    "Legacy's simple online assistant helps you prepare a meaningful life story to share.",
  button: {
    text: 'Learn More',
    href: `${appConfig().vanityDomain}/obitwriter`,
    class: 'WriterButton',
  },
};

const ObitWriterCTA = () => (
  <div className={styles.ObitWriterCTA}>
    <CTABlock blurb={data.blurb} button={data.button} title={data.title} />
  </div>
);

export default ObitWriterCTA;



// WEBPACK FOOTER //
// ./src/reactModules/pages/Planning/components/ObitWriterCTA/index.js